import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { StockOpname } from 'services/action';

import { Page, Button } from 'ui/components';

import {
  FormAdjusmentItems,
  FormBulkImport,
  FormInput,
  FormItems,
} from './component/form';

const initialState = {
  ready: false,
  form: null,
  items: [],
  adjusment: null,
};

const CreateScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const selectedWarehouse = useSelector((state) => state?.Auth?.selectedWarehouse);

  const [{ form, items, adjusment }, setState] = React.useState(initialState);
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleItemsChange = (v) => {
    setState((prevState) => ({ ...prevState, items: v }));
    forceUpdate();
  };

  const $handleAdjusmentChange = (v) => {
    setState((prevState) => ({ ...prevState, adjusment: v }));
    forceUpdate();
  };

  const $handleSubmit = async () => {
    const payload = {
      warehouse_id: selectedWarehouse?.id,
      type: form?.type,
      note: form?.note,
    };

    if (form?.type === 'opname') {
      payload.items = items;
    }

    if (form?.type === 'adjustment') {
      payload.items = adjusment?.items;
    }

    const submit = await Dispatch(StockOpname.$create(payload));

    if (submit?.message === 'success') {
      History.replace(`/inventory/stockopname/${submit?.data?.id}`);
    }
  };

  const $handleItemsOpnameChange = async (i, e) => {
    let newItems = [...items];
    newItems[i][e.target.name] = e.target.valueNumber;

    setState((prevState) => ({ ...prevState, items: newItems }));
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  return (
    <Page type="form" className="bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Buat Stockopname" />

      <Page.Body className="d-block px-3">
        <div className="row">
          <div className="col-md-4 border-end">
            <FormInput onInputChange={$handleFormChange} />
          </div>
          {form?.type === 'opname' && (
            <div className="col-md-8 ">
              <div className="ps-3">
                {form?.type === 'opname' && (
                  <FormBulkImport setItems={$handleItemsChange} />
                )}
                {items && (
                  <FormItems
                    data={items}
                    onInputChange={$handleItemsOpnameChange}
                  />
                )}
              </div>
            </div>
          )}
          {form?.type === 'adjustment' && (
            <div className="col-md-8 ">
              <div className="ps-3">
                <FormAdjusmentItems onInputChange={$handleAdjusmentChange} />
              </div>
            </div>
          )}
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/inventory/stockopname`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
